const articleStatuses = {
	DRAFT: "draft",
	READY: "ready",
};

export default articleStatuses;
